import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import StripeCheckoutForm from "./StripeCheckoutForm";

import "./PaymentRequired.scss";
import { useTranslation } from "react-i18next";
import { Fragment } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { devLog } from "utils/devLog";

const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;

//devLog("Stripe Key:", STRIPE_KEY);
const stripePromise = loadStripe("" + STRIPE_KEY);

//function which serves as a container for the strip custom component modified for our specific application, which all presents the general text about the user needed to pay out of pocket, should they reach this screen
export default function PaymentRequired(props) {
  const { t } = useTranslation();
  const [quoteAmount, setQuoteAmount] = useState(props.quoteAmount);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    calQuoteAmount();
  }, []);

  const calQuoteAmount = () => {
    devLog("Check quoteAmount: ", quoteAmount);
    if (quoteAmount) {
      const amt = (quoteAmount / 100).toFixed(2);
      devLog("Has quoteAmount: ", amt);
      setQuoteAmount(amt);
      setLoading(false);
    } else {
      const amt = (0).toFixed(2);
      devLog("Dont quoteAmount: ", amt);
      setQuoteAmount(amt);
      setLoading(false);
    }
  };

  return (
    <>
      {!loading && (
        <Fragment>
          {/* <!-- CC PAYMENT INFORMATION --> */}
          <div className="paymentBase">
            <div className="text">
              <h4 style={{ textAlign: "center" }}>
                <strong>{t("description.PaymentRequiredText1")}</strong>
              </h4>
              <div className="darkBase">
                <div id="cc-amount-due1" style={{ fontSize: 60 }}>
                  <strong>${quoteAmount}</strong>
                </div>
                <div style={{ fontSize: 18 }}>
                  <strong>{t("description.PaymentRequiredText4")}</strong>
                </div>
              </div>
              <h5>
                {t("description.PaymentRequiredText2")}
                <span id="cc-amount-due2">
                  {/* ${(quoteAmount / 100).toFixed(2) || (0).toFixed(2)} */}${quoteAmount}
                </span>
                {t("description.PaymentRequiredText2_5")}
                <br />
                <br />
                {t("description.PaymentRequiredText3")}
              </h5>
            </div>
            <div className="cc-card-declined text" style={{ display: "none" }}>
              <h5 className="errorText">{t("description.PaymentRequiredCancelPayment")}</h5>
            </div>

            {/* Stripe Checkout Form */}
            <Elements stripe={stripePromise}>
              <StripeCheckoutForm
                companyParams={props.companyParams}
                quoteAmount={props.quoteAmount}
                quoteCurrency={props.quoteCurrency}
                encCallGUID={props.encCallGUID}
                partnerCode={props.partnerCode}
                onUserCancel={props.onUserCancel}
              />
            </Elements>

            <div
              style={{
                paddingLeft: "3rem",
                paddingRight: "3rem",
                paddingTop: "1rem",
              }}
            >
              {/* <button
            className="paymentBase ui-btn"
            onClick={() => {
              // todo: cancel the call -- do "cancelcall"
              if (typeof props.onUserCancel === "function") {
                props.onUserCancel();
              } else {
                console.warn("PaymentRequired", "No cancel callback available");
              }
            }}
          >
            {t("description.PaymentRequiredButton2")}
          </button> */}
            </div>
          </div>
        </Fragment>
      )}
    </>
  );
}
